var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-container" },
    [
      _c("BjPage", {
        ref: "BjPage",
        attrs: {
          "label-width": "80px",
          "query-params": _vm.queryParams,
          "col-span": _vm.colSpan,
          "get-action": _vm.queryApi,
          serial: false,
          selection: _vm.selection,
          "before-reset-search": _vm.beforeResetSearch,
        },
        on: {
          handleSelectionChange: _vm.handleSelectionChange,
          showSetting: _vm.SortableTable.show,
          "header-dragend": _vm.SortableTable.handleHeaderDragend,
          "header-contextmenu": _vm.SortableTable.handleHeaderContextmenu,
        },
        scopedSlots: _vm._u([
          {
            key: "baseForm",
            fn: function () {
              return [
                _c(
                  "el-col",
                  { attrs: { span: _vm.colSpan } },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t(
                            "AccountManagement.staff.preferredName"
                          ),
                          prop: "staffName",
                        },
                      },
                      [
                        _c("BjInput", {
                          attrs: {
                            placeholder: _vm.$t(
                              "AccountManagement.staff.preferredName"
                            ),
                          },
                          nativeOn: {
                            keyup: function ($event) {
                              if (
                                !$event.type.indexOf("key") &&
                                _vm._k(
                                  $event.keyCode,
                                  "enter",
                                  13,
                                  $event.key,
                                  "Enter"
                                )
                              ) {
                                return null
                              }
                              return _vm.handleQuery.apply(null, arguments)
                            },
                          },
                          model: {
                            value: _vm.queryParams.staffName,
                            callback: function ($$v) {
                              _vm.$set(_vm.queryParams, "staffName", $$v)
                            },
                            expression: "queryParams.staffName",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { span: _vm.colSpan } },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t("AccountManagement.staff.type"),
                          prop: "staffType",
                        },
                      },
                      [
                        _c("BjSelectLov", {
                          attrs: {
                            "option-list": _vm.staffTypeList,
                            placeholder: _vm.$t("AccountManagement.staff.type"),
                          },
                          on: { change: _vm.handleQuery },
                          model: {
                            value: _vm.queryParams.staffType,
                            callback: function ($$v) {
                              _vm.$set(_vm.queryParams, "staffType", $$v)
                            },
                            expression: "queryParams.staffType",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { span: _vm.colSpan } },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t("AccountManagement.staff.department"),
                          prop: "staffDepartment",
                        },
                      },
                      [
                        _c("BjSelectLov", {
                          attrs: {
                            "option-list": _vm.staffDepartmentList,
                            clearable: !_vm.deptDis,
                            placeholder: _vm.$t(
                              "AccountManagement.staff.department"
                            ),
                          },
                          on: { change: _vm.handleQuery },
                          model: {
                            value: _vm.queryParams.staffDepartment,
                            callback: function ($$v) {
                              _vm.$set(_vm.queryParams, "staffDepartment", $$v)
                            },
                            expression: "queryParams.staffDepartment",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { span: _vm.colSpan } },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t("AccountManagement.staff.role"),
                          prop: "staffRole",
                        },
                      },
                      [
                        _c("BjSelectLov", {
                          attrs: {
                            "option-list": _vm.staffRoleList,
                            placeholder: _vm.$t("AccountManagement.staff.role"),
                          },
                          on: { change: _vm.handleQuery },
                          model: {
                            value: _vm.queryParams.staffRole,
                            callback: function ($$v) {
                              _vm.$set(_vm.queryParams, "staffRole", $$v)
                            },
                            expression: "queryParams.staffRole",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]
            },
            proxy: true,
          },
          {
            key: "tableOperation",
            fn: function () {
              return [
                _c(
                  "el-col",
                  [
                    _c(
                      "el-button",
                      {
                        staticClass: "main-btn",
                        attrs: { type: "primary" },
                        on: {
                          click: function ($event) {
                            return _vm.onAdd()
                          },
                        },
                      },
                      [_vm._v(_vm._s(_vm.$t("addText")))]
                    ),
                    _vm.havePermission
                      ? _c(
                          "el-button",
                          {
                            staticClass: "main-btn",
                            on: {
                              click: function ($event) {
                                return _vm.showDecryptDialog()
                              },
                            },
                          },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.$t("AccountManagement.staff.decryptRates")
                              )
                            ),
                          ]
                        )
                      : _vm._e(),
                  ],
                  1
                ),
              ]
            },
            proxy: true,
          },
          {
            key: "tableColumn",
            fn: function () {
              return [
                _vm._l(_vm.dropCols, function (col, index) {
                  return [
                    col.prop !== "bjTableAction"
                      ? _c("el-table-column", {
                          key:
                            "col_" +
                            index +
                            "_" +
                            col.prop +
                            "_" +
                            (col.width || "auto"),
                          attrs: {
                            prop: col.prop,
                            label: col.label,
                            width: col.width || "auto",
                            fixed: col.fixed || false,
                            align: "center",
                            "class-name": "item",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    col.prop == "staffType"
                                      ? [
                                          _c("span", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  _vm.staffTypeList.bjGet(
                                                    scope.row[col.prop]
                                                  )
                                                )
                                              )
                                            ),
                                          ]),
                                        ]
                                      : col.prop == "staffDepartment"
                                      ? [
                                          _c("span", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  _vm.staffDepartmentList.bjGet(
                                                    scope.row[col.prop]
                                                  )
                                                )
                                              )
                                            ),
                                          ]),
                                        ]
                                      : col.prop == "staffRole"
                                      ? [
                                          _c("span", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  _vm.staffRoleList.bjGet(
                                                    scope.row[col.prop]
                                                  )
                                                )
                                              )
                                            ),
                                          ]),
                                        ]
                                      : _vm.isHourlyRateProp(col.prop)
                                      ? [
                                          _c("span", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.getHourlyRateCellText(
                                                  scope.row,
                                                  col.prop
                                                )
                                              )
                                            ),
                                          ]),
                                        ]
                                      : [
                                          _vm._v(
                                            _vm._s(
                                              _vm._f("timeFilters")(
                                                scope.row[col.prop],
                                                scope.row[col.prop]
                                              )
                                            )
                                          ),
                                        ],
                                  ]
                                },
                              },
                            ],
                            null,
                            true
                          ),
                        })
                      : _vm._e(),
                    col.prop === "bjTableAction"
                      ? _c("el-table-column", {
                          key:
                            "col_" +
                            index +
                            "_" +
                            col.prop +
                            "_" +
                            (col.width || "auto"),
                          attrs: {
                            prop: col.prop,
                            label: col.label,
                            width: col.width || "auto",
                            fixed: col.fixed || "right",
                            align: "center",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (props) {
                                  return [
                                    [
                                      _c(
                                        "el-button",
                                        {
                                          staticClass: "edit-btn",
                                          attrs: { type: "text" },
                                          on: {
                                            click: function ($event) {
                                              return _vm.onEdit(props.row)
                                            },
                                          },
                                        },
                                        [_vm._v(_vm._s(_vm.$t("editText")))]
                                      ),
                                      _c(
                                        "el-button",
                                        {
                                          staticClass: "delete-btn",
                                          attrs: { type: "text" },
                                          on: {
                                            click: function ($event) {
                                              return _vm.onDel(props.row)
                                            },
                                          },
                                        },
                                        [_vm._v(_vm._s(_vm.$t("delText")))]
                                      ),
                                    ],
                                  ]
                                },
                              },
                            ],
                            null,
                            true
                          ),
                        })
                      : _vm._e(),
                  ]
                }),
              ]
            },
            proxy: true,
          },
        ]),
      }),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.dialogTitle,
            visible: _vm.dialogFormVisible,
            width: "450px",
            "before-close": _vm.handleClose,
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogFormVisible = $event
            },
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "form",
              attrs: {
                model: _vm.form,
                "label-position": "top",
                rules: _vm.rules,
              },
            },
            [
              _c(
                "el-row",
                { attrs: { gutter: 20 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("AccountManagement.staff.legalName"),
                            prop: "legalName",
                          },
                        },
                        [
                          _c("BjInput", {
                            attrs: {
                              placeholder: _vm.$t(
                                "AccountManagement.staff.legalName"
                              ),
                            },
                            model: {
                              value: _vm.form.legalName,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "legalName", $$v)
                              },
                              expression: "form.legalName",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t(
                              "AccountManagement.staff.preferredName"
                            ),
                            prop: "staffName",
                          },
                        },
                        [
                          _c("BjInput", {
                            attrs: {
                              placeholder: _vm.$t(
                                "AccountManagement.staff.preferredName"
                              ),
                            },
                            model: {
                              value: _vm.form.staffName,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "staffName", $$v)
                              },
                              expression: "form.staffName",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-row",
                { attrs: { gutter: 20 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("AccountManagement.staff.type"),
                            prop: "staffType",
                          },
                        },
                        [
                          _c("BjSelectLov", {
                            attrs: {
                              "option-list": _vm.staffTypeList,
                              placeholder: _vm.$t(
                                "AccountManagement.staff.type"
                              ),
                            },
                            model: {
                              value: _vm.form.staffType,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "staffType", $$v)
                              },
                              expression: "form.staffType",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("AccountManagement.staff.department"),
                            prop: "staffDepartment",
                          },
                        },
                        [
                          _c("BjSelectLov", {
                            attrs: {
                              "option-list": _vm.staffDepartmentList,
                              placeholder: _vm.$t(
                                "AccountManagement.staff.department"
                              ),
                            },
                            model: {
                              value: _vm.form.staffDepartment,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "staffDepartment", $$v)
                              },
                              expression: "form.staffDepartment",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-row",
                { attrs: { gutter: 20 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("AccountManagement.staff.role"),
                            prop: "staffRole",
                          },
                        },
                        [
                          _c("BjSelectLov", {
                            attrs: {
                              "option-list": _vm.staffRoleList,
                              placeholder: _vm.$t(
                                "AccountManagement.staff.role"
                              ),
                            },
                            model: {
                              value: _vm.form.staffRole,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "staffRole", $$v)
                              },
                              expression: "form.staffRole",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm.havePermission
                ? _c(
                    "el-row",
                    { attrs: { gutter: 20 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t(
                                  "AccountManagement.staff.hourlyRateWithLeave"
                                ),
                                prop: "hourlyRateWithLeaveCiphertext",
                              },
                            },
                            [
                              _vm.formHourlyRateEditable
                                ? _c("BjInputMoney", {
                                    attrs: {
                                      min: 0,
                                      "not-auto-zero": true,
                                      placeholder: _vm.$t(
                                        "AccountManagement.staff.hourlyRateWithLeave"
                                      ),
                                    },
                                    model: {
                                      value:
                                        _vm.form.hourlyRateWithLeaveCiphertext,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.form,
                                          "hourlyRateWithLeaveCiphertext",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "form.hourlyRateWithLeaveCiphertext",
                                    },
                                  })
                                : _c("BjInput", {
                                    attrs: {
                                      disabled: "",
                                      placeholder: _vm.$t(
                                        "AccountManagement.staff.hourlyRateWithLeave"
                                      ),
                                    },
                                    model: {
                                      value:
                                        _vm.form.hourlyRateWithLeaveCiphertext,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.form,
                                          "hourlyRateWithLeaveCiphertext",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "form.hourlyRateWithLeaveCiphertext",
                                    },
                                  }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t(
                                  "AccountManagement.staff.regularHourlyRate"
                                ),
                                prop: "regularHourlyRateCiphertext",
                              },
                            },
                            [
                              _vm.formHourlyRateEditable
                                ? _c("BjInputMoney", {
                                    attrs: {
                                      min: 0,
                                      "not-auto-zero": true,
                                      placeholder: _vm.$t(
                                        "AccountManagement.staff.regularHourlyRate"
                                      ),
                                    },
                                    model: {
                                      value:
                                        _vm.form.regularHourlyRateCiphertext,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.form,
                                          "regularHourlyRateCiphertext",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "form.regularHourlyRateCiphertext",
                                    },
                                  })
                                : _c("BjInput", {
                                    attrs: {
                                      disabled: "",
                                      placeholder: _vm.$t(
                                        "AccountManagement.staff.regularHourlyRate"
                                      ),
                                    },
                                    model: {
                                      value:
                                        _vm.form.regularHourlyRateCiphertext,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.form,
                                          "regularHourlyRateCiphertext",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "form.regularHourlyRateCiphertext",
                                    },
                                  }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c("el-button", { on: { click: _vm.handleClose } }, [
                _vm._v(_vm._s(_vm.$t("cancelText"))),
              ]),
              _c(
                "el-button",
                {
                  attrs: { type: "primary", loading: _vm.saving },
                  on: {
                    click: function ($event) {
                      return _vm.onSave()
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("okText")))]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.$t("AccountManagement.staff.decryptRates"),
            visible: _vm.decryptDialogVisible,
            width: "600px",
            "before-close": _vm.handleDecryptClose,
          },
          on: {
            "update:visible": function ($event) {
              _vm.decryptDialogVisible = $event
            },
          },
        },
        [
          _c(
            "el-form",
            { attrs: { "label-position": "top" } },
            [
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: _vm.$t("AccountManagement.staff.privateKey"),
                  },
                },
                [
                  _c("el-input", {
                    attrs: {
                      type: "textarea",
                      autosize: { minRows: 8, maxRows: 12 },
                      placeholder: _vm.$t(
                        "AccountManagement.staff.privateKeyPlaceholder"
                      ),
                    },
                    model: {
                      value: _vm.decryptForm.privateKey,
                      callback: function ($$v) {
                        _vm.$set(_vm.decryptForm, "privateKey", $$v)
                      },
                      expression: "decryptForm.privateKey",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-upload",
                {
                  attrs: {
                    action: "#",
                    "auto-upload": false,
                    "show-file-list": false,
                    "on-change": _vm.handlePrivateKeyFileChange,
                  },
                },
                [
                  _c("el-button", [
                    _vm._v(
                      _vm._s(_vm.$t("AccountManagement.staff.uploadPrivateKey"))
                    ),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c("el-button", { on: { click: _vm.handleDecryptClose } }, [
                _vm._v(_vm._s(_vm.$t("cancelText"))),
              ]),
              _c(
                "el-button",
                {
                  attrs: { type: "primary", loading: _vm.decrypting },
                  on: {
                    click: function ($event) {
                      return _vm.onDecryptConfirm()
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("okText")))]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }